import store from '@/store'
export function isMobile() {
  // 只會算一次
  // return window.innerWidth < 768

  // 動態isMobile
  return store.state.isMobile
}
